// Angular
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgImageSliderModule } from 'ng-image-slider';
import { nl2brPipe } from './nl2br.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Modulos
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbModule } from './breadcrumb/breadcrumb.module'

// Componentes
import { AppComponent } from './app.component';
import { HomeComponent } from './layout/home/home.component';
import { HeaderComponent } from './Header/header/header.component';
import { FooterComponent } from './Footer/footer/footer.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { RecuperarPasswordComponent } from './recuperar-password/recuperar-password.component';
import { NuevaPasswordComponent } from './nueva-password/nueva-password.component'


// Layouts
import { DetalleProductosComponent } from './layout/productos/detalle-productos/detalle-productos.component';
import { RegistroComponent } from './layout/registro/registro.component';
import { MenuComponent } from './layout/Menus/menu/menu.component';
import { ProductosComponent } from './layout/productos/productos.component';
import { VerificarComponent } from './layout/verificar/verificar.component';

// Paginas
import { PoliticasComponent } from './Pages/politicas/politicas.component';
import { NosotrosComponent } from './Pages/nosotros/nosotros.component';
import { PrivacidadComponent } from './Pages/privacidad/privacidad.component';
import { OrdenarComponent } from './Pages/ordenar/ordenar.component';
import { BandasComponent } from './Pages/bandas/bandas.component';

// Shared
import { ScrollToTopComponent } from './shared/scroll-to-top/scroll-to-top.component';
import { CookieConsentComponent } from './shared/cookie-consent/cookie-consent.component';
import { MoneyPipe } from './shared/money.pipe';


// Providers
// RECORDATORIO, solicitar las KEYS, 
// Google actualizo los login, ninguno funciona
import { SocialLoginModule, SocialAuthServiceConfig, FacebookLoginProvider, GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { GoogleLoginProvider } from '@abacritt/angularx-social-login';


import { environment } from '../environments/environment';

// Angular Material para eliminar, presindimos de material para usar 100% Bootstrap y homologar diseño
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import localeEs from '@angular/common/locales/es';
import { AuthInterceptor } from './interceptors/auth.interceptor';


registerLocaleData(localeEs);

@NgModule({ 
    declarations: [
        
        AppComponent,
        HeaderComponent,
        FooterComponent,
        HomeComponent,
        ProductosComponent,
        MenuComponent,
        DetalleProductosComponent,
        nl2brPipe,
        RegistroComponent,
        VerificarComponent,
        PoliticasComponent,
        NosotrosComponent,
        PrivacidadComponent,
        BandasComponent,
        OrdenarComponent,
        CookieConsentComponent,
        
    ],
    bootstrap: [
        AppComponent
    ], 
    imports: [
        ScrollToTopComponent,
        MoneyPipe,
        BreadcrumbModule,
        NgbModule,
        BrowserModule,
        NgImageSliderModule,
        FormsModule,
        ReactiveFormsModule,
        SocialLoginModule,
        GoogleSigninButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        MatIconModule,
        MatSelectModule,
        MatButtonModule,
        MatPaginatorModule,
        // MatOptionModule,
        NativeDateModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatTableModule,
        NgbCarouselModule,
        MatTabsModule,
        MatProgressSpinnerModule,    
        RouterModule.forRoot([
            { path: 'recuperar-password', component: RecuperarPasswordComponent },
            { path: 'nueva-password/:crytemail', component: NuevaPasswordComponent },
            { path: '', component: HomeComponent, pathMatch: 'full' },
            { path: 'home', 
                component: HomeComponent, 
                data:{ breadcrumb: 'Inicio' }, 
            },
            { path: 'prod/:IdCategoria/:Busqueda', component: ProductosComponent,},
            { path: 'prod/:IdCategoria/:Busqueda/:Cat', component: ProductosComponent, },
            { path: 'prod/:IdCategoria', component: ProductosComponent, },
            { path: 'productos', component: ProductosComponent, },
            { path: 'categoria/:slug', component: ProductosComponent },
            { path: 'producto/:slug', component: DetalleProductosComponent },
            { path: 'detalleProd', component: DetalleProductosComponent, },
            { path: 'detalleProd/:id', component: DetalleProductosComponent, },
            { path: 'detalleProd/:id/:slug', component: DetalleProductosComponent, },
            { path: 'Register', component: RegistroComponent },
            { path: 'Verificar/:CrypMail', component: VerificarComponent },
            { path: 'perfil', loadChildren: () => import('./layout/perfil/perfil.module').then(m => m.PerfilModule) },
            { path: 'cart', loadChildren: () => import('./layout/carrito/carrito.module').then(m => m.CarritoModule) },
            { path: 'privacidad',
                component: PrivacidadComponent,
                data: { breadcrumb: 'Términos y Condiciones de Uso'} },
            { path: 'politicas',
                component: PoliticasComponent,
                data: { breadcrumb: 'Políticas de Envío'} },
            { path: 'nosotros',
                component: NosotrosComponent,
                data: { breadcrumb: '¿Quiénes somos?'} },
            { path: 'ordenar', 
                component: OrdenarComponent,
                data: { breadcrumb: '¿Cómo ordenar?'} },
            { path: 'bandas', 
                component: BandasComponent,
                data: { breadcrumb: 'Bandas Sinfónicas / Educación'} },
            { path: 'checkout', loadChildren: () => import('./layout/checkout/checkout.module').then(m => m.CheckoutModule) },
            { path: 'finalizar', loadChildren: () => import('./layout/finalizar-compra/finaliza/finaliza.module').then(m => m.FinalizaModule) },
            { path: '**', component: NotFoundComponent },
        ], { initialNavigation: 'enabledBlocking' }),
        BrowserAnimationsModule,
        // ServiceWorkerModule.register('ngsw-worker.js', {
        //     enabled: environment.production,
        //     // Register the ServiceWorker as soon as the app is stable
        //     // or after 30 seconds (whichever comes first).
        //     registrationStrategy: 'registerWhenStable:30000'
        // }
        // )
        ], 

    providers: [
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(environment.googleClientId)
                    },
                    {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        provider: new FacebookLoginProvider(environment.facebookAppId)
                    }
                ]
            } as SocialAuthServiceConfig,
        },
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        provideClientHydration(withEventReplay()),
        { provide: LOCALE_ID, useValue: 'es' }, // 👈 idioma global
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ] })
export class AppModule { }
